module.exports = function (link) {
  var html = "\n  <div class=\"link-preview\">\n          <a class=\"saito-link\" ";
  var info = ['title', 'display_url', 'description'];
  var include_graphics = true;
  if (!link.url.includes(window.location.host)) {
    html += "target=\"_blank\" rel='noopener noreferrer' ";
  } else {
    html += "data-link=\"local_link\" ";

    //info = ['title', 'description'];
    var index = link.url.indexOf(window.location.host) + window.location.host.length + 1;
    var slug = link.url.substring(index);
    if (slug.includes('/')) {
      slug = slug.split('/')[0];
    }
    if (slug.includes('?')) {
      slug = slug.split('?')[0];
    }
    var filters = link.app.modules.returnFirstRespondTo('saito-filter-link', {
      modname: link.mod.returnName(),
      slug: slug,
      url: link.url
    });
    if (filters !== null && filters !== void 0 && filters.info) {
      info = filters === null || filters === void 0 ? void 0 : filters.info;
    }
    if (filters !== null && filters !== void 0 && filters.no_photo) {
      include_graphics = false;
    }

    // ---> Use a respondTo to further customize which info to include and add a class...
  }
  var img_src = '/saito/img/dreamscape.png';
  if (link.src) {
    img_src = link.src;
  }
  html += "href=\"".concat(link.url, "\">\n            <div class=\"link-container\">");
  if (include_graphics) {
    html += "<div class=\"link-img ".concat(link.show_photo ? 'has-picture' : '', "\">\n                <img src=\"").concat(img_src, "\">\n              </div>");
  }
  if (info.length > 0) {
    html += "<div class=\"link-info\">";
    for (var i = 0; i < info.length; i++) {
      html += "<div class=\"link-".concat(info[i], "\">").concat(link[info[i]], "</div>");
    }
    html += '</div>';
  }
  html += "\n            </div>\n          </a>\n        </div>\n    ";
  return html;
};